import { toast } from 'react-toastify';
import services from '../services';
import { getLocalStorageItem } from './Localstorage/localStorageUtils';
import { canAddTicketToList, canMoveTicketOutOfList } from './ticketMovePermission';

// Everyone except admins is restricted (managers included). userData may be double-encoded.
const getRestrictedUser = () => {
    let currentUser = getLocalStorageItem('userData');
    if (typeof currentUser === 'string') {
        try {
            currentUser = JSON.parse(currentUser);
        } catch {
            currentUser = null;
        }
    }
    if (!currentUser?.id) return null;
    return currentUser.role?.toLowerCase() === 'admin' ? null : currentUser;
};

const fetchAssignments = async (userId) => {
    const response = await services.userassignboard.GET_UserAssignBoard_ID(userId);
    return response?.data?.data || [];
};

const parseListIds = (raw) => {
    let list = raw;
    if (typeof list === 'string') {
        try {
            list = JSON.parse(list);
        } catch {
            list = [];
        }
    }
    return (Array.isArray(list) ? list : []).map((l) => l?.value ?? l?.id ?? l);
};

// Boards (from GET_BOARD_LIST) narrowed to the boards and lists the user is assigned to.
export const filterBoardsForUser = async (boards) => {
    const currentUser = getRestrictedUser();
    if (!currentUser || !Array.isArray(boards)) return boards;

    const assignments = await fetchAssignments(currentUser.id);
    return boards
        .filter((board) => assignments.some((a) => a.boardId === board.id))
        .map((board) => {
            const assignment = assignments.find((a) => a.boardId === board.id);
            const ids = parseListIds(assignment?.boardListId);
            const allLists = assignment?.isManager === true || ids.length === 0 || ids.includes('*');
            return allLists
                ? board
                : { ...board, BoardLists: (board.BoardLists || []).filter((col) => ids.includes(col.id)) };
        });
};

// Checks "add to destination list" and, for an existing ticket, "move out of source list".
// Shows a toast and resolves false when the move is not allowed.
export const checkTicketMove = async ({ destBoardId, destListId, sourceBoardId, sourceListId }) => {
    const currentUser = getRestrictedUser();
    if (!currentUser) return true;

    try {
        const assignments = await fetchAssignments(currentUser.id);
        const assignmentFor = (boardId) => assignments.find((a) => a.boardId === boardId);

        // "Add" applies to new tickets and cross-board moves; moving within a board only needs "move out".
        const needsAdd = !sourceListId || sourceBoardId !== destBoardId;
        if (needsAdd) {
            const target = assignmentFor(destBoardId);
            if (!canAddTicketToList(target?.permissions, destListId)) {
                toast.error("You don't have permission to add tickets to this list");
                return false;
            }
        }

        if (sourceListId && sourceListId !== destListId) {
            const source = assignmentFor(sourceBoardId);
            if (!canMoveTicketOutOfList(source?.permissions, sourceListId)) {
                toast.error("You don't have permission to move tickets out of this list");
                return false;
            }
        }
        return true;
    } catch (e) {
        console.error(e);
        return false;
    }
};
